import { configureStore } from "@reduxjs/toolkit";
import AuthReducers from "./Reducers/AuthReducers";
import SpotsReducer from "./Reducers/SpotsReducer";
import VehiclesReducer from "./Reducers/VehiclesReducer";
import BookingReducer from "./Reducers/BookingReducer";
import AdminReducer from "./Reducers/AdminReducer";

export const store = configureStore({
  reducer: {
    auth: AuthReducers,
    spots: SpotsReducer,
    vehicles: VehiclesReducer,
    bookings: BookingReducer,
    admin: AdminReducer,
  },
});
